import { PageHeader, Tabs } from 'antd';
import React, { FC, useContext } from 'react';
import { ChangePassword } from '../components/ChangePassword';
import { Link } from 'react-router-dom';

import { AppContext } from '../../../modules/core/contexts/AppContext';
import { isEditor } from '../../../modules/core/components/PrivateRoute';
import { hasFeature, FeatureFlag } from '../../../helpers/featureFlags';
import config from '../../../config';

const getProfilesURL = (props: any): string => {
  const id = props.match.params.id;
  return `/organizations/${id}/profiles`;
};

export const SettingsContainer: FC<{}> = (props): JSX.Element => {
  const { currentOrganization } = useContext(AppContext);

  const isSSO = currentOrganization?.hasSso || currentOrganization?.hasSsoStrict;

  const tabs = [
    <Tabs.TabPane tab="Change Password" key="1">
      {isSSO ? <p>You can change your password in your SSO portal.</p> : <ChangePassword />}
    </Tabs.TabPane>,
  ];

  if (isEditor(currentOrganization)) {
    tabs.push(
      <Tabs.TabPane tab="Edit your profiles" key="2">
        <div className="user-profiles-link">
          <Link to={getProfilesURL(props)}>Go to your profiles</Link>
        </div>
      </Tabs.TabPane>
    );
  }

  if (hasFeature(currentOrganization?.featureFlags, FeatureFlag.MfaEnabledTemp)) {
    tabs.push(<Tabs.TabPane tab="Multi-Factor Authentication" key="3" />);
  }

  const handleTabChange = (key: string) => {
    if (key === '3') {
      window.location.assign(`${config.endpoint}/mfa/settings?organization_id=${currentOrganization?.id}`);
    }
  };

  return (
    <div className="main-content">
      <PageHeader title="Settings">
        <Tabs defaultActiveKey="1" tabPosition="left" className="tabs-wrapper" onChange={handleTabChange}>
          {tabs}
        </Tabs>
      </PageHeader>
    </div>
  );
};
